import { motion } from "motion/react";
import { useTranslation } from "react-i18next";

export default function Process() {
  const { t } = useTranslation();

  return (
    <section id="process" className="py-24 bg-surface-container-low border-y border-outline-variant scroll-mt-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="mb-16 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-on-surface mb-4">{t('process.title')}</h2>
          <p className="text-on-surface-variant max-w-xl mx-auto">{t('process.subtitle')}</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {[0, 1, 2].map((idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.15 }}
              className="relative bg-white border border-outline-variant p-8 rounded-xl text-center"
            >
              <div className="w-14 h-14 bg-primary-container text-white rounded-full flex items-center justify-center text-xl font-bold mx-auto mb-6 shadow-lg">
                {t(`process.steps.${idx}.num`)}
              </div>
              <h3 className="text-xl font-bold text-on-surface mb-3">{t(`process.steps.${idx}.title`)}</h3>
              <p className="text-on-surface-variant text-sm leading-relaxed">{t(`process.steps.${idx}.description`)}</p>
              {idx < 2 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 w-8 h-0.5 bg-outline-variant" />
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
